const Header: React.FC = () => {
  return (
    <header className='max-w-[1162px] mx-auto px-[25px]'>
      <hgroup className='pt-[114px] lg:pt-[169px]'>
        <h1 className='text-center ml-[17px] text-[32px]/9 lg:text-7xl/[80px] font-semibold !text-transparent dark:!text-transparent bg-clip-text bg-[radial-gradient(50%_111.11%_at_50%_50%,_#000_11%,_rgba(22,22,22,0.60)100%)] dark:bg-[radial-gradient(50%_111.11%_at_50%_50%,#fff_77.5%,#ffffff99_100%)]'>
          Launch a Loan Marketplace
          <br />
          In Just Minutes
        </h1>
        <p className='hidden lg:block mt-6 lg:mt-[45px] text-primary-grey-150 dark:text-white-dark text-center text-base lg:text-2xl font-normal lg:font-medium'>Enabling dApps to launch Digital and RWA loan marketplaces.</p>
        <p className='lg:hidden mt-6 lg:mt-[45px] text-primary-grey-150 dark:text-white-dark text-center text-base lg:text-2xl font-normal lg:font-medium'>NettyWorth's AI loan protocol lets dApps, Games, NFTs, and RWA projects launch marketplaces and earn revenue.</p>
      </hgroup>

      <a rel='noopener noreferrer' target='_blank' href='https://5vx6x80c2zf.typeform.com/to/No8JcIrA?typeform-source=docs.nettyworth.io' type='button' className='mt-[45px] mx-auto rounded sm:w-[228px] w-full h-[42px] flex items-center justify-center !bg-primary text-white px-6 py-2 text-base/5 font-medium'>
        Request Form
      </a>
      <div className='!bg-coal-border max-h-[419px] mt-16 lg:mt-[72px] rounded-[33px] flex justify-between pt-3 lg:pt-6 px-3 lg:px-6 lg:gap-6 gap-3 overflow-hidden'>
        <img src='/images/api-sdk-demo-ui.png' alt='api' className='hidden lg:flex flex-1 max-w-[418px] w-full h-[519px] object-contain' />
        <img src='/images/api-sdk-demo-code.svg' alt='api-sdk image' className='flex-1 w-[calc(50%-36px)] object-contain lg:object-cover rounded-t-3xl' />
      </div>
    </header>
  );
};

export default Header;
